import { useEffect, useState } from "react";
import { useAppSelector } from "../store";
import { ResponseItemDataType } from "../types/proposalTypes";

export default function useIsInCart(proposal: ResponseItemDataType | null) {
  const { applications } = useAppSelector((state) => state.cart);
  const [isInCart, setIsInCart] = useState(false);

  useEffect(() => {
    if (!proposal) return;
    let temp = applications.find((elem) => elem.id === proposal.id);
    if (temp) {
      setIsInCart(true);
    } else {
      setIsInCart(false);
    }
  }, [proposal, applications]);

  return isInCart;
}
